import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarousel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 479,
	height: 477,
	viewBox: "0 0 479 477",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M81 398V432C81 456.853 101.147 477 126 477H434C458.853 477 479 456.853 479 432V124C479 99.1472 458.853 79 434 79H398V109H434C442.284 109 449 115.716 449 124V432C449 440.284 442.284 447 434 447H126C117.716 447 111 440.284 111 432V398H81Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 15,
		y: 15,
		width: 368,
		height: 368,
		rx: 30,
		stroke: "white",
		strokeWidth: 30,
		fill: "transparent"
	})]
});
export default SvgCarousel;
